import AccumulateSegmentCashPromotionController
  from "partial/OfferManager/modules/AccumulateSegmentCashPromotion/AccumulateSegmentCashPromotionController";

export default AccumulateSegmentCashPromotionController